<!--suppress ALL -->
<template>
  <div>
    <DateRangeDialog
      :value="showDateRangePicker"
      @cancel-operation="showDateRangePicker=false"
      @filter-approval-dates="filterApprovalDates"
    />
    <v-expansion-panels focusable dark>
      <v-expansion-panel @click="showFilter = !showFilter">
        <v-expansion-panel-header color="secondary">
          <v-row v-if="isFilterApprovalsByStatusActive && manager" align="center">
            <v-col :cols="getColsForFilterBar">
              <Multiselect
                v-model="statusValues"
                :options="statusOptions.map((word) => toTitleCase(word))"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="false"
                :preselect-first="false"
                :searchable="false"
                :show-labels="false"
                :style="{ maxWidth: getWidthFilterBar }"
                :placeholder="$t('actions.filterByStatus')"
                class="statusFilter"
                @click.native.stop
              />
            </v-col>
            <v-col :cols="getColsForRangeButton">
              <v-btn
                class="rangeButton"
                @click.native.stop="selectDateRange()"
              >
                {{ $t('actions.selectRange') }}..
              </v-btn>
            </v-col>
            <v-col :cols="getColsForConfirmButton">
              <v-icon size="40" @click.native.stop="changeStatusFilter">
                check_circle
              </v-icon>
            </v-col>
          </v-row>
          <v-row v-else>
              {{ expansionPanelTitle }}
          </v-row>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="pt-2" color="white">
          <v-card width="100%" flat light class="mb-n2">
            <v-card-title class="pa-0">
              <v-container fluid class="pa-0">
                <v-row align="center">
                  <v-col cols="12">
                    <v-card flat color="grey lighten-4" light>
                      <v-row>
                        <v-col cols="12" md="2" xl="1" min-width="88" class="py-0">
                          <v-card
                            flat
                            light
                            :width="showFilterTitle ? '100%' : '88px'"
                            color="secondary"
                            height="100%"
                          >
                            <v-row justify="center" class="fill-height">
                              <v-col cols="3" v-if="showFilterTitle"/>
                              <v-col cols="6" md="12" class="pa-0">
                                <v-row justify="center" class="fill-height">
                                  <v-icon v-show="!isMobile()" dark :size="'50'">
                                    filter_list_alt
                                  </v-icon>
                                  <v-card-title
                                    v-if="showFilterTitle"
                                    style="color: white"
                                  >
                                    {{$t('filters.applyFilters')}}
                                </v-card-title>
                              </v-row>
                            </v-col>
                            <v-col cols="3" align="end" v-if="showFilterTitle">
                              <v-tooltip top v-if="showFilterTitle" :disabled="isMobile()">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    v-on="on"
                                    :disabled="addFilterButtonDisabled"
                                    icon
                                    outlined
                                    dark
                                    class="mr-4"
                                    @click="saveCurrentFilter"
                                  >
                                    <v-icon>
                                      add
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span> {{ $t('filters.addFilter')}}</span>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                        <v-col class="py-0">
                          <v-row align="end" justify="center">
                            <v-col class="mr-3">
                              <v-row align="center" justify="end" class="px-3 flex-sm-nowrap">
                                <v-select
                                  v-model="filteredAttribute"
                                  :items="filterableAttributes"
                                  :style="{ width: getInputWidth, maxWidth: getInputMaxWidth }"
                                  :label="`${ $t('filters.selectFilterField') }:`"
                                  :placeholder="`${ $t('tables.noneSelected')}`"
                                  prepend-icon="menu"
                                  class="mr-1 ml-3 mt-2"
                                  clearable
                                  outlined
                                  hide-details
                                  @click:clear="clearFilterOptions"
                                />
                                <v-combobox
                                  v-model="selectedFilters"
                                  :disabled="filterOptionsDisabled"
                                  :items="getFilteredAttributeOptions"
                                  :style="{ width: getInputWidth, maxWidth: getInputMaxWidth }"
                                  :label="`${ $t('filters.filterOnChosen') }`"
                                prepend-icon="menu_open"
                                class="mr-1 ml-3 mt-2"
                                multiple
                                outlined
                                hide-details
                                clearable
                                small-chips
                              >
                                <template v-slot:selection="{ item, parent, selected }">
                                  <v-chip
                                    :input-value="selected"
                                    small
                                  >
                                    <span class="pr-2 text-truncate">{{ item }}</span>
                                    <v-icon
                                      small
                                      right
                                      @click="parent.selectItem(item)"
                                    >
                                      cancel
                                    </v-icon>
                                  </v-chip>
                                </template>
                              </v-combobox>
                              <v-tooltip top v-if="!showFilterTitle" :disabled="isMobile()">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    v-on="on"
                                    :disabled="addFilterButtonDisabled"
                                    icon
                                    outlined
                                    class="ml-3"
                                    @click="saveCurrentFilter"
                                  >
                                    <v-icon dark>
                                      add
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span> {{$t('filters.addFilter')}}</span>
                                </v-tooltip>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-divider/>
                <v-row>
                  <v-col cols="12">
                    <v-card flat color="grey lighten-4" class="body-1 px-4 py-2">
                      {{ $t('filters.activeFilters') }}
                      <v-chip
                        v-for="(filter, i) in activeFilters"
                        v-bind:key="i"
                        class="mx-2 my-2"
                        close
                        @click:close="handleFilterRemoval(filter)"
                      >
                        <div>
                          {{ filter.filteredAttribute }}:
                          {{ concatListItems(filter.selectedFilters) }}
                        </div>
                      </v-chip>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import join from 'lodash/join';
import map from 'lodash/map';
import uniq from 'lodash/uniq';

import getTimePairClockingType from '@/mixins/timepairs/getTimePairClockingType';
import isMobile from '@/mixins/displayAdaptable';
import hasWorkScheduleFeatures from '@/mixins/hasWorkScheduleFeatures';
import hasTimePairFeatures from '@/mixins/timepairs/hasTimePairFeatures';

import constants from '@/constants';
import Multiselect from 'vue-multiselect';
import DateRangeDialog from '@/components/dialogs/DateRangeDialog.vue';

export default {
  name: 'TimePairFilterBar',

  mixins: [
    getTimePairClockingType,
    isMobile,
    hasWorkScheduleFeatures,
    hasTimePairFeatures,
  ],

  props: {
    manager: {
      type: Boolean,
      required: true,
    },
    timePairs: Array,
  },

  components: {
    DateRangeDialog,
    Multiselect,
  },

  data() {
    return {
      showFilter: false,
      filteredAttribute: null,
      selectedFilters: [],
      statusValues: [],
      statusOptions: [
        this.$t('status.APPROVED'),
        this.$t('status.PENDING'),
        this.$t('status.REJECTED'),
        this.$t('status.INCOMPLETE'),
        this.$t('status.PENDING_DELETE'),
      ],
      showDateRangePicker: false,
    };
  },

  watch: {
    approvalStatusConfiguration() {
      this.statusValues = [];
      this.approvalStatusConfiguration.forEach((status) => {
        this.statusValues.push(this.toTitleCase(this.$t('status.'.concat(status))));
      });
    },
  },

  methods: {
    ...mapActions(['addFilter', 'removeFilter']),

    saveCurrentFilter() {
      this.addFilter({
        filter: {
          filteredAttribute: this.filteredAttribute,
          selectedFilters: this.selectedFilters,
        },
        isApproval: this.manager,
      });
      this.selectedFilters = [];
      this.filteredAttribute = null;

      this.$emit('filter-added');
    },

    changeStatusFilter() {
      let values;
      if (this.statusValues.length > 0) {
        values = this.statusValues.map((word) => this.getEnglishTranslatedStatus(word));
      } else {
        values = [constants.Approvals.Status.APPROVED, constants.Approvals.Status.PENDING,
          constants.Approvals.Status.REJECTED, constants.Approvals.Status.PENDING_DELETE,
          constants.Approvals.Status.INCOMPLETE];
      }
      this.$emit('status-filter-changed', values.map((word) => word.toUpperCase()));
    },

    getEnglishTranslatedStatus(word) {
      switch (word) {
        case this.$t('status.APPROVED'):
          return constants.Approvals.Status.APPROVED;
        case this.$t('status.PENDING'):
          return constants.Approvals.Status.PENDING;
        case this.$t('status.REJECTED'):
          return constants.Approvals.Status.REJECTED;
        case this.$t('status.INCOMPLETE'):
          return constants.Approvals.Status.INCOMPLETE;
        case this.$t('status.PENDING_DELETE'):
          return constants.Approvals.Status.PENDING_DELETE;
        default:
          return '';
      }
    },

    handleFilterRemoval(clearedFilter) {
      this.removeFilter({
        filter: clearedFilter,
        isApproval: this.manager,
      });

      this.$emit('filter-removed');
    },

    concatListItems(items) {
      return join(items, ', ');
    },

    clearFilterOptions() {
      this.selectedFilters = [];
    },

    toTitleCase(value) {
      const words = value.replace('_', ' ').split(' ');

      for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1).toLowerCase();
      }

      return words.join(' ');
    },

    selectDateRange() {
      this.showDateRangePicker = true;
    },

    filterApprovalDates(values) {
      this.showDateRangePicker = false;
      this.$emit('filter-approval-dates', values);
    },
  },

  computed: {
    ...mapState([
      'activeFilters',
      'approvalStatusConfiguration',
    ]),

    expansionPanelTitle() {
      return this.showFilter ? this.$t('filters.hide') : this.$t('filters.show');
    },

    filterableAttributes() {
      const attributes = [
        {
          name: this.$t('tableHeaders.position'),
          filterable: true,
        },
        {
          name: this.$t('clock.clockIn'),
          filterable: true,
        },
        {
          name: this.$t('clock.clockOut'),
          filterable: true,
        },
        {
          name: this.$t('misc.type'),
          filterable: this.manager,
        },
        {
          name: this.$t('workSchedules.workScheduleDeviation'),
          filterable: this.isWorkScheduleFilterEnabled,
        },
      ];

      const currentlyFilteredAttributes = map(this.activeFilters, (activeFilter) => activeFilter.filteredAttribute);

      return map(
        filter(
          attributes,
          (attribute) => attribute.filterable && !currentlyFilteredAttributes.includes(attribute.name),
        ),
        (attribute) => attribute.name,
      );
    },

    getFilteredAttributeOptions() {
      switch (this.filteredAttribute) {
        case this.$t('tableHeaders.position'): {
          return uniq(map(this.timePairs,
            (timePair) => timePair.employeeAssignment.position.description));
        }
        case this.$t('clock.clockIn'):
        case this.$t('clock.clockOut'):
          return ['AM', 'PM'];
        case this.$t('workSchedules.workScheduleDeviation'): {
          return [this.$t('workSchedules.underTime'), this.$t('workSchedules.overtime')];
        }
        case this.$t('misc.type'): {
          return uniq(map(this.timePairs, (timePair) => this.getTimePairClockingType(timePair)));
        }
        default:
          return [];
      }
    },

    isWorkScheduleFilterEnabled() {
      return (this.manager && this.isWorkScheduleManagerViewFeatureEnabled)
        || (!this.manager && this.isWorkScheduleEmployeeViewFeatureEnabled);
    },

    filterOptionsDisabled() {
      return isEmpty(this.filteredAttribute);
    },

    addFilterButtonDisabled() {
      return isEmpty(this.selectedFilters);
    },

    showFilterTitle() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm': {
          return true;
        }
        case 'md':
        case 'lg':
        case 'xl':
        default: {
          return false;
        }
      }
    },

    getInputWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': {
          return '100%';
        }
        case 'sm':
        case 'md':
        case 'lg':
        case 'xl':
        default: {
          return '20vw';
        }
      }
    },

    getInputMaxWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': {
          return 'calc(100vw - 110px)';
        }
        case 'sm':
        case 'md':
        case 'lg':
        case 'xl':
        default: {
          return '450px';
        }
      }
    },

    getWidthFilterBar() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': {
          return '200px';
        }
        case 'sm': {
          return '250px';
        }
        case 'md':
        case 'lg': {
          return '400px';
        }
        case 'xl': {
          return '450px';
        }
        default: {
          return '250px';
        }
      }
    },

    getColsForFilterBar() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': {
          return '10';
        }
        case 'sm': {
          return '5';
        }
        case 'md':
        case 'lg': {
          return '3';
        }
        case 'xl': {
          return '2';
        }
        default: {
          return '5';
        }
      }
    },

    getColsForRangeButton() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': {
          return '9';
        }
        case 'sm': {
          return '5';
        }
        case 'md':
        case 'lg': {
          return '8';
        }
        case 'xl': {
          return '9';
        }
        default: {
          return '6';
        }
      }
    },

    getColsForConfirmButton() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': {
          return '3';
        }
        case 'sm': {
          return '2';
        }
        case 'md': {
          return '1';
        }
        case 'lg':
        case 'xl':
        default: {
          return '1';
        }
      }
    },
  },

  created() {
    this.statusValues = [];
    this.approvalStatusConfiguration.forEach((status) => {
      this.statusValues.push(this.toTitleCase(this.$t('status.'.concat(status))));
    });
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"/>

<style scoped>
.rangeButton {
  color: var(--v-secondary-base) !important;
  background-color: white !important;
  text-transform: unset;
  min-width: 120px !important;
  max-width: 160px !important;
  padding: 0 5px;
}
</style>

<style>
.statusFilter ul, .statusFilter ol {
  padding: 0 !important;
}

.statusFilter .multiselect__content-wrapper {
  position: unset !important;
}
</style>
